/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize, useOutsideClickEffect } from '@saviynt/common';
import {
  Box,
  ButtonSelect,
  MobileDrawerItem,
  Typography,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { FIRST_TIME_BADGE_DISABLED } from '../../../components/ViewControls/ColumnsFilter/constant';
import { httpService } from '../../../http-service/httpService';
import {
  setPersonalizationViewOption,
  setTriggerForUserDefaultView,
  updatePersonalizationAll,
} from '../../../redux/certdetails/action';
import { axiosTimeoutConfig } from '../../../redux/certdetails/types';
import { URL_UPDATE_FILTER_API } from '../../../redux/certdetails/urls';
import { VIEW_OPTIONS } from '../../../utils/constant';
import { getMessageKey } from '../../../utils/utils';

import './CertsPersonalization.css';

function ViewOptions({ isOpenViewOption, setIsOpenViewOption, isOnMobile }) {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { messages } = useSelector((state) => state?.user);

  const {
    global: { certKey },
  } = useSelector((state) => state?.certifications?.details);
  const selectedViewOption = useSelector(
    (state) => state?.certifications?.details?.personalization?.viewOption?.view
  );
  const viewOptionRef = useRef('viewOption');

  useOutsideClickEffect(viewOptionRef, () => {
    setIsOpenViewOption(false);
  });

  const resetCertsFilter = async () => {
    await httpService.post(
      URL_UPDATE_FILTER_API,
      {
        certkey: certKey,
        clearFilter: 'true',
      },
      axiosTimeoutConfig
    );
  };

  const handleOnClick = (event) => {
    const clickedText = event.value;

    resetCertsFilter();

    if (clickedText === VIEW_OPTIONS.MY_PERSONALIZED_VIEW) {
      dispatch(
        setPersonalizationViewOption({
          view: VIEW_OPTIONS.MY_PERSONALIZED_VIEW,
          applied: true,
        })
      );
    } else if (clickedText === VIEW_OPTIONS.DEFAULT_VIEW) {
      dispatch(
        setPersonalizationViewOption({
          view: VIEW_OPTIONS.DEFAULT_VIEW,
          applied: true,
        })
      );
      FIRST_TIME_BADGE_DISABLED.count = 0;

      dispatch(
        updatePersonalizationAll({
          advancedFilters: false,
          rows: false,
          columns: false,
        })
      );

      dispatch(setTriggerForUserDefaultView(true));
    }

    setIsOpenViewOption(false);
  };

  const handleClick = () => {
    setIsOpenViewOption(!isOpenViewOption);
  };

  if (isOnMobile) {
    const options = [
      {
        label:
          messages['PERSONALIZATION.DEFAULT_VIEW.ATTESTATIONS'] ||
          localize(
            intl,
            getMessageKey('PERSONALIZATION.DEFAULT_VIEW.ATTESTATIONS')
          ),
        value: VIEW_OPTIONS.DEFAULT_VIEW,
        isChecked: selectedViewOption === VIEW_OPTIONS.DEFAULT_VIEW,
        isDisabled: false,
        isRadio: true,
      },
      {
        label:
          messages['PERSONALIZATION.MY_PERSONALIZED_VIEW.ATTESTATIONS'] ||
          localize(
            intl,
            getMessageKey('PERSONALIZATION.MY_PERSONALIZED_VIEW.ATTESTATIONS')
          ),
        value: VIEW_OPTIONS.MY_PERSONALIZED_VIEW,
        isChecked: selectedViewOption === VIEW_OPTIONS.MY_PERSONALIZED_VIEW,
        isDisabled: false,
        isRadio: true,
      },
    ];

    return (
      <Box className='CertPersonalization--ViewOptionsMobile'>
        <Typography kind='h4'>
          {messages.PERSONALIZATION_VIEW_OPTIONS ||
            localize(intl, getMessageKey('PERSONALIZATION_VIEW_OPTIONS'))}
        </Typography>
        {options.map((option) => (
          <MobileDrawerItem
            option={option}
            onClick={() => handleOnClick(option)}
          />
        ))}
      </Box>
    );
  }

  return (
    <div
      className='CertPersonalization--ViewOptionsContainer'
      ref={viewOptionRef}>
      <ButtonSelect
        label={
          messages[selectedViewOption] ||
          localize(intl, getMessageKey(selectedViewOption))
        }
        ariaLabel={
          messages[selectedViewOption] ||
          localize(intl, getMessageKey(selectedViewOption))
        }
        onClick={handleClick}
        isOpen={isOpenViewOption}
        size='medium'
      />
      {isOpenViewOption ? (
        <div className='CertPersonalization--ViewOptions'>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
          <ul>
            <li
              className={
                selectedViewOption === VIEW_OPTIONS.MY_PERSONALIZED_VIEW
                  ? 'selected'
                  : ''
              }
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleOnClick({
                    value: VIEW_OPTIONS.MY_PERSONALIZED_VIEW,
                  });
                }
              }}
              onClick={() => {
                handleOnClick({
                  value: VIEW_OPTIONS.MY_PERSONALIZED_VIEW,
                });
              }}
              role='button'
              tabIndex={0}>
              {messages['PERSONALIZATION.MY_PERSONALIZED_VIEW.ATTESTATIONS'] ||
                localize(
                  intl,
                  getMessageKey(
                    'PERSONALIZATION.MY_PERSONALIZED_VIEW.ATTESTATIONS'
                  )
                )}
            </li>
            <li
              className={
                selectedViewOption === VIEW_OPTIONS.DEFAULT_VIEW
                  ? 'selected'
                  : ''
              }
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleOnClick({
                    value: VIEW_OPTIONS.DEFAULT_VIEW,
                  });
                }
              }}
              onClick={() => {
                handleOnClick({
                  value: VIEW_OPTIONS.DEFAULT_VIEW,
                });
              }}
              role='button'
              tabIndex={0}>
              {messages['PERSONALIZATION.DEFAULT_VIEW.ATTESTATIONS'] ||
                localize(
                  intl,
                  getMessageKey('PERSONALIZATION.DEFAULT_VIEW.ATTESTATIONS')
                )}
            </li>
          </ul>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}

ViewOptions.defaultProps = {};

ViewOptions.propTypes = {
  isOpenViewOption: PropTypes.bool.isRequired,
  setIsOpenViewOption: PropTypes.func.isRequired,
  isOnMobile: PropTypes.bool.isRequired,
};

export default ViewOptions;
